import { CircularProgress } from '@mui/material';

import { PaletteColorsT } from 'shared/models/mui';

import './LoaderSection.scss';

interface LoaderSectionProps {
  size?: number;
  disableShrink?: boolean;
  color?: PaletteColorsT;
}
function LoaderSection({
  size = 35,
  color = 'secondary',
  disableShrink,
}: LoaderSectionProps) {
  return (
    <div className="loader-section">
      <CircularProgress
        variant="determinate"
        className="loader-section__spinner"
        size={size}
        value={100}
        sx={{
          color: (theme) => (
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
          ),
        }}
      />
      <CircularProgress
        variant="indeterminate"
        className="loader-section__spinner"
        size={size}
        color={color}
        disableShrink={disableShrink}
      />
    </div>
  );
}

export default LoaderSection;
